import React from 'react';
import { Link } from 'react-router-dom';
import WIcon from 'resources/W_icon_reward_banner.png';
import WStoreIcon from 'resources/Button-WStore.svg';
import TreeGraphic from './assets/Miami graphic.png';
import './GetMoreRewardsCard.scss';

const GetMoreRewardsCard = ({ isPreferredLocationPls }) => {
  const rewardCardIcon = isPreferredLocationPls ? TreeGraphic : WIcon;

  return (
    <div className="get-more-rewards-card">
      <img className="reward-card-tree-graphic" src={rewardCardIcon} alt="" />
      <div className="more-rewards-title">Get More Rewards!</div>
      <img className="reward-wstore-icon" src={WStoreIcon} alt="" />
      <div className="reward-subtext">WStore</div>
      <Link to="/wstore" className="shop-wstore-button">
        SHOP WSTORE
      </Link>
    </div>
  );
};

export default GetMoreRewardsCard;
